import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode, selectMode } from '../../../service/slice/ThemeSlice';
import { MdOutlineLightMode } from "react-icons/md";
import { MdOutlineDarkMode } from "react-icons/md";
import img1 from "../../../adminassets/img/background.png";
import logo from "../../../studentassets/logo.png";


export default function AdminForgot() {

    const navigate = useNavigate();
    const [email, setEmail] = useState();

    const theme = useSelector(selectMode);
    const dispatch = useDispatch();

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : '#151A24'
    };

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();

        // Regex for email validation
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!email) {
            toast.info("Please enter an email address!");
            return;
        }
        if (!re.test(email)) {
            toast.info("Please enter a valid email address!");
            return;
        }

        const resetData = {
            email: email
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/resetpassword`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(resetData),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("OTP has been sent to your email!");
                navigate("../adminotpverify", { state: resetData });
            } else {
                toast.error("Invalid Email ID!");
                navigate("/adminForgot");
            }
            setEmail("");

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    };

    return (
        <>
            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-white py-2 fixed-top" style={{ ...themeColor, height: "80px" }}>
                <div className="container-fluid">
                    {/* Logo */}
                    <Link to="/" className="navbar-brand">
                        <img src={logo} alt="Logo" style={{ width: '96px', marginTop: "0.4em" }} />
                    </Link>

                    {/* Right Side */}
                    <div className="d-flex align-items-center gap-3 d-none d-md-flex">

                        <button className="theme-toggle-btn" onClick={() => dispatch(toggleMode())} style={themeColor}>
                            {theme === "light" ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
                        </button>

                    </div>
                </div>
            </nav>

            <div className="">
                <div className="row vh-100">

                    <div className="col-12 col-md-6 p-0 ms-0">
                        <img src={img1} alt="img" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
                    </div>


                    <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
                        <form onSubmit={(event) => handleSubmit(event)} className="w-75">

                            <h2 className="mb-4 text-center">Reset Your Password</h2>

                            <div className="mb-3">
                                <input className="form-control form-control-lg" type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="Put Email for reset password" />
                            </div>

                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary btn-lg">
                                    Send OTP
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </>
    )
}
